// Chakra imports
import {
  Button,
  Flex,
  Grid,
  Icon,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
// Assets
import avatar2 from "assets/img/avatars/avatar2.png";
import avatar4 from "assets/img/avatars/avatar4.png";
import avatar6 from "assets/img/avatars/avatar6.png";
import imageArchitect1 from "assets/img/ImageArchitect1.png";
import imageArchitect2 from "assets/img/ImageArchitect2.png";
import imageArchitect3 from "assets/img/ImageArchitect3.png";
// Custom components
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import React from "react";
import { FaPlus } from "react-icons/fa";
import ProjectCard from "./ProjectCard";

const Projects = ({ title, description }) => {
  // Chakra color mode
  const textColor = useColorModeValue("gray.700", "white");

  return (
    <Card style={{ background: 'white' }} b='white' style ={{ background: 'white'}} p='16px' my='24px'>
      <CardHeader p='12px 5px' mb='12px'>
        <Flex direction='column'>
          <Text fontSize='lg' color={textColor} fontWeight='bold'>
            {title}
          </Text>
          <Text fontSize='sm' color='gray.500' fontWeight='400'>
            {description}
          </Text>
        </Flex>
      </CardHeader>
      <CardBody px='5px'>
        <Grid
          templateColumns={{ sm: "1fr", md: "1fr 1fr", xl: "repeat(3, 1fr)" }}
          templateRows={{ sm: "1fr 1fr 1fr auto", md: "1fr 1fr", xl: "1fr" }}
          gap='24px'>
          <ProjectCard
            image={"https://www.youtube.com/embed/RnfaVM6KSr8"}
            name={"Video #1"}
            category={"General UI Overview"}
            description={
              "A general overview on how the admin ui works and its basic capabilities"
            }
            avatars={[avatar2, avatar4, avatar6]}
          />
          <ProjectCard
            image={"https://www.youtube.com/embed/lroyot6hjnc"}
            name={"Video #2"}
            category={"Add document"}
            description={
              "Walkthrough video on how to add new documents to the database."
            }
            avatars={[avatar4, avatar2, avatar6, avatar4]}
          />
          <ProjectCard
            image={"https://www.youtube.com/embed/ugvmHM7KWSU"}
            name={"Video #3"}
            category={"Edit document"}
            description={
              "Walkthrough video on how to edit already existing documents."
            }
            avatars={[avatar2, avatar4, avatar6]}
          />
        </Grid>
      </CardBody>
    </Card>
  );
};

export default Projects;
